"use client";

import { c as _c } from "react/compiler-runtime";
import { ChatMarkdown } from "../chat-markdown";
import { useAIChatMessageContext } from "../contexts";
interface AIChatMessageContentProps {
  className?: string;
}
export function AIChatMessagePreamble(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  const {
    message
  } = useAIChatMessageContext();
  if (!message.preamble) {
    return null;
  }
  let t1;
  if ($[0] !== message.preamble) {
    t1 = <ChatMarkdown content={message.preamble} />;
    $[0] = message.preamble;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== t1) {
    t2 = <div className={className}>{t1}</div>;
    $[2] = className;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function AIChatMessageContent(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  const {
    message
  } = useAIChatMessageContext();
  const content = typeof message.content === "string" ? message.content : String(message.content || "");
  if (!content) {
    return null;
  }
  let t1;
  if ($[0] !== content) {
    t1 = <ChatMarkdown content={content} />;
    $[0] = content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== t1) {
    t2 = <div className={className}>{t1}</div>;
    $[2] = className;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}